"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBusinessParsedResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Address_1 = require("./Address");
const PhoneNumber_1 = require("./PhoneNumber");
const BusinessClient_1 = require("./BusinessClient");
function transformBusinessParsedResponse(business) {
    return {
        id: business.id,
        name: business.name,
        accountId: business.account_id !== null ? business.account_id.toString() : '',
        address: business.address !== null ? (0, Address_1.transformAddressParsedResponse)(business.address) : null,
        phoneNumber: business.phone_number !== null ? (0, PhoneNumber_1.transformPhoneNumberParsedResponse)(business.phone_number) : null,
        businessClients: business.business_clients.map((client) => (0, BusinessClient_1.transformBusinessClientParsedResponse)(client)),
    };
}
exports.transformBusinessParsedResponse = transformBusinessParsedResponse;
//# sourceMappingURL=Business.js.map